module.exports = __webpack_public_path__ + "static/img/8.3093ff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/8.png
// module id = zCNR
// module chunks = 0